/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetJobApplicationUsageStatistics interface.
 */
export function instanceOfGetJobApplicationUsageStatistics(value) {
    if (!('likeFractionLast14Days' in value) || value['likeFractionLast14Days'] === undefined)
        return false;
    if (!('likeCountLast14Days' in value) || value['likeCountLast14Days'] === undefined)
        return false;
    return true;
}
export function GetJobApplicationUsageStatisticsFromJSON(json) {
    return GetJobApplicationUsageStatisticsFromJSONTyped(json, false);
}
export function GetJobApplicationUsageStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'likeFractionLast14Days': json['likeFractionLast14Days'],
        'likeCountLast14Days': json['likeCountLast14Days'],
    };
}
export function GetJobApplicationUsageStatisticsToJSON(json) {
    return GetJobApplicationUsageStatisticsToJSONTyped(json, false);
}
export function GetJobApplicationUsageStatisticsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'likeCountLast14Days': value['likeCountLast14Days'],
    };
}
